<template>
  <div class="form-text">
    <label v-if="label" :for="id" class="form__label">
      {{ label }}
    </label>
    <input
      :id="id"
      ref="input-text"
      v-model="model"
      v-bind="attributes"
      class="form-text__input">
  </div>
</template>

<script>
  import { nanoid } from 'nanoid';

  export default {
    name: 'FormText',
    props: {
      attr: {
        type: Object,
        required: true,
        default: () => {},
      },
      label: {
        type: String,
        required: false,
        default: () => '',
      },
      value: {
        type: String,
        required: true,
        default: () => '',
      },
    },
    data() {
      return {
        id: nanoid(),
      };
    },
    computed: {
      model: {
        get() {
          return this.value;
        },
        set(value) {
          this.$emit('input', value);
        },
      },
      attributes() {
        const attributes = { ...this.attr };

        if ('placeholder' in attributes) {
          const { placeholder } = attributes;
          attributes.placeholder = this.$t(placeholder);
        }

        if ('title' in attributes) {
          const { title } = attributes;
          attributes.title = this.$t(title);
        }

        // Set `text` as the default value
        if (!{}.hasOwnProperty.call(attributes, 'type')) {
          attributes.type = 'text';
        }

        return attributes;
      },
    },
  };
</script>

<style lang="scss">
  @mixin form-text() {
    display: flex;
    align-items: center;
    width: 100%;
    height: 58px;
    padding: 0 s(4);
    font-family: inherit;
    font-size: 1em;
    font-weight: 300;
    line-height: 32px;
    color: c('blue');
    background-color: transparent;
    border: 2px solid c('grey');
    border-radius: 5px;

    &::placeholder {
      color: currentColor;
      opacity: 0.5;
    }
    &:hover {
      border-color: rgba(c('blue'), 0.25);
    }
    &:focus {
      border-color: rgba(c('blue'), 0.6);
    }
  }
  /*------------------------------------*
    Form input text
  *------------------------------------*/
  .form-text__input {
    @include form-text;
  }
</style>
